import {HStack, Show} from 'platform/foundation';

import {use, useState} from 'react';

import {slice} from 'ramda';

import {useGetAssignmentsQuery} from '@dms/api/core';

import {TestIdProps} from 'shared/web';

import {AssignmentButton} from './AssignmentButton';
import {AssignmentContext} from './AssignmentContext';
import {AssignmentCreatePopup} from './AssignmentCreatePopup';
import {AssignOption} from './AssignOption';
import {AssignUsers} from './AssignUsers';

export const AssignmentContainer = (props: TestIdProps) => {
  const context = use(AssignmentContext);
  const [showCreatePopup, setCreatePopup] = useState(false);

  const {
    data: assignments = [],
    isFetching: _isFetching,
    isLoading: _isLoading,
  } = useGetAssignmentsQuery({
    assignmentIdentityType: context.type,
    assignmentIdentityId: context.assignmentIdentityId,
  });

  return (
    <>
      <HStack spacing={1}>
        <Show when={assignments.length > 0}>
          <AssignUsers data-testid={props['data-testid']} assignment={assignments?.[0]} />
        </Show>
        <Show when={assignments.length > 1}>
          <AssignOption
            data-testid={props['data-testid']}
            assignments={slice(1, Infinity, assignments)}
          />
        </Show>
        <AssignmentButton
          assignedUsers={assignments ?? []}
          onCreateExternalUserClick={() => setCreatePopup(true)}
          data-testid={props['data-testid']}
        />
      </HStack>
      <Show when={showCreatePopup}>
        <AssignmentCreatePopup
          data-testid={props['data-testid']}
          modalEvent={(value) => setCreatePopup(value ?? false)}
        />
      </Show>
    </>
  );
};
